import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Icon } from "@iconify/react";

const CustomerListTable = () => {
    const [customers, setCustomers] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [searchQuery, setSearchQuery] = useState("");

    // Fetch Customers
    const fetchCustomers = async () => {
        try {
            const response = await fetch(
                `${process.env.REACT_APP_BASE_URL}customer/all-customers`
            );
            const result = await response.json();

            if (result?.status_code === 200) {
                setCustomers(result.result);
            } else {
                console.error("Failed to fetch customers:", result?.message);
            }
        } catch (error) {
            console.error("Error fetching customers:", error);
        }
    };

    useEffect(() => {
        fetchCustomers();
    }, []);

    // Filtering
    const filteredCustomers = customers.filter((customer) => {
        const query = searchQuery.trim().toLowerCase();
        return (
            customer.first_name?.toLowerCase().includes(query) ||
            customer.last_name?.toLowerCase().includes(query) ||
            customer.email?.toLowerCase().includes(query) ||
            customer.customer_id?.toLowerCase().includes(query)
        );
    });

    // Pagination
    const totalPages = Math.ceil(filteredCustomers.length / itemsPerPage);
    const startIndex = (currentPage - 1) * itemsPerPage;
    const paginatedCustomers = filteredCustomers.slice(
        startIndex,
        startIndex + itemsPerPage
    );

    const handleSearchChange = (event) => {
        setSearchQuery(event.target.value);
        setCurrentPage(1);
    };

    const handleItemsPerPageChange = (event) => {
        setItemsPerPage(Number(event.target.value));
        setCurrentPage(1);
    };

    const handleNext = () => {
        if (currentPage < totalPages) setCurrentPage((prev) => prev + 1);
    };

    const handlePrev = () => {
        if (currentPage > 1) setCurrentPage((prev) => prev - 1);
    };

    return (
        <div>
            {/* Breadcrumbs & Title */}
            <div className="d-flex flex-wrap align-items-center justify-content-between gap-3 mb-24">
                <h6 className="fw-semibold mb-0">Customer List</h6>
                <ul className="d-flex align-items-center gap-2">
                    <li className="fw-medium">
                        <Link to="/" className="d-flex align-items-center gap-1 hover-text-primary">
                            <Icon icon="solar:home-smile-angle-outline" className="icon text-lg" />
                            Dashboard
                        </Link>
                    </li>
                    <li> - </li>
                    <li className="fw-medium">Customer List</li>
                </ul>
            </div>

            <div className="card">
                <div className="card-header d-flex flex-wrap align-items-center justify-content-between gap-3">
                    <div className="d-flex align-items-center gap-2">
                        <span>Show</span>
                        <select
                            className="form-select form-select-sm w-auto"
                            value={itemsPerPage}
                            onChange={handleItemsPerPageChange}
                        >
                            <option value="5">5</option>
                            <option value="10">10</option>
                            <option value="15">15</option>
                            <option value="20">20</option>
                            <option value={filteredCustomers.length}>All</option>
                        </select>
                    </div>

                    <div className="icon-field">
                        <input
                            type="text"
                            className="form-control form-control-sm w-auto"
                            placeholder="Search by Name, Email or Customer ID"
                            onChange={handleSearchChange}
                        />
                        <span className="icon">
                            <Icon icon="ion:search-outline" />
                        </span>
                    </div>
                </div>

                <div className="card-body" style={{ overflowX: "auto" }}>
                    <table className="table bordered-table mb-0">
                        <thead>
                            <tr>
                                <th>S.L</th>
                                <th>Customer ID</th>
                                <th>First Name</th>
                                <th>Last Name</th>
                                <th>Email Address</th>
                                <th>Mobile No</th>
                            </tr>
                        </thead>

                        <tbody>
                            {paginatedCustomers.length === 0 ? (
                                <tr>
                                    <td colSpan="7" className="text-center">
                                        No customers found.
                                    </td>
                                </tr>
                            ) : (
                                paginatedCustomers.map((customer, index) => (
                                    <tr key={customer.customer_id}>
                                        <td>{startIndex + index + 1}</td>
                                        <td>{customer.customer_id}</td>
                                        <td>{customer.first_name}</td>
                                        <td>{customer.last_name}</td>
                                        <td>{customer.email}</td>
                                        <td>{customer.phone_number}</td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>

                    {/* Pagination */}
                    <div className="d-flex justify-content-end align-items-center gap-4 mt-3">
                        <button
                            className="btn btn-sm"
                            onClick={handlePrev}
                            disabled={currentPage === 1}
                            style={{
                                backgroundColor: "#545454",
                                color: "white",
                                border: "none",
                                padding: "10px 40px",
                                height: "auto",
                            }}
                        >
                            Prev
                        </button>

                        <span>
                            Page {currentPage} of {totalPages || 1}
                        </span>

                        <button
                            className="btn btn-sm"
                            onClick={handleNext}
                            disabled={currentPage === totalPages || totalPages === 0}
                            style={{
                                backgroundColor: "#545454",
                                color: "white",
                                border: "none",
                                padding: "10px 40px",
                                height: "auto",
                            }}
                        >
                            Next
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CustomerListTable;
